import { useSyncExternalStore } from "react";
import { getSnapshot, subscribe } from "../lib/offline/reachability.ts";

export function useOnlineStatus(): boolean {
	return useSyncExternalStore(subscribe, getSnapshot, () => true);
}
